var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdSleepQq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EFF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3768 12.352C29.1813 11.6747 28.7651 11.0784 28.1917 10.6539C27.6183 10.2293 26.9189 9.99974 26.2 10H21.8C20.2893 10 19.0133 10.9951 18.6232 12.352M29.3768 12.352C29.4575 12.6306 29.5 12.9264 29.5 13.2308C29.5 13.5164 29.3841 13.7903 29.1778 13.9923C28.9715 14.1942 28.6917 14.3077 28.4 14.3077H19.6C19.3083 14.3077 19.0285 14.1942 18.8222 13.9923C18.6159 13.7903 18.5 13.5164 18.5 13.2308C18.5 12.9264 18.544 12.6306 18.6232 12.352M29.3768 12.352C30.3243 12.4224 31.2659 12.5099 32.2031 12.6162C33.8164 12.8 35 14.1627 35 15.7536V34.7692C35 35.6261 34.6523 36.4478 34.0335 37.0537C33.4146 37.6596 32.5752 38 31.7 38H16.3C15.4248 38 14.5854 37.6596 13.9665 37.0537C13.3477 36.4478 13 35.6261 13 34.7692V15.7536C13 14.1627 14.1821 12.8 15.7969 12.6162C16.7371 12.5096 17.6794 12.4215 18.6232 12.352",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1003 21.1992L29.1336 21.2104M17.9431 21.1992H17.9336V21.2104",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6097 25.3984L29.1336 25.4096M17.9431 25.3984H17.9336V25.4096",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6097 30.0664L29.1336 30.0776M17.9431 30.0664H17.9336V30.0776",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2002 20.0571L17.7431 21.6L20.3145 18",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdSleepQq);
export default __webpack_public_path__ + "static/media/sd-sleep-qq.22bfaa72e9bb294d576c6f18be0a182f.svg";
export { ForwardRef as ReactComponent };